<template>
	<div v-if="event && channel_id">
		<template v-if="type == 'source' || type == 'destination'">
			<channel :channel="channel_id" :event="event" :type="type" :show-instance="true"></channel>
		</template>
		<template v-if="type == 'stats'">
			<connection-stats :channel="event.event_group.channel_id" :destchannel="event.channel_id" :event="event"></connection-stats>
		</template>
	</div>
</template>
<script>
import EventModel from '@/models/event.js'
import Channel from './Channel.vue'
import ConnectionStats from './ConnectionStats.vue'

export default {
	props: ['uuid',"type"],
	components: {
		Channel,
		ConnectionStats
	},
	data() {
    var ch = this.$cloudserver.channel("events:"+this.uuid);
		return {
			ws_channel: ch,
			event: ch.data
		}
	},
	watch: {
		"ws_channel.data": {
			handler(newVal, oldVal) {
				this.event = newVal;
			},
			deep: true
		}
	},
	computed: {
		channel_id() {
			if (typeof(this.event) == "undefined") return;
			if (typeof(this.event.event_group) == "undefined") return;
			if (this.type == "source") return this.event.event_group.channel_id;
			return this.event.channel_id;
		},
		title() {
			return EventModel.title(this.event);
		}
	},
	mounted () {
		if(this.ws_channel) this.ws_channel.join();
	},
	beforeDestroy() {
		if(this.ws_channel) this.ws_channel.leave();
	}
}
</script>